<template>
  <div id="app" style="padding: 0px;" class="h-100">
    <router-view />
  </div>
</template>



<script>
import settings from './settings.coffee';
import Vue from 'vue';
import moment from "moment";

// Filtres Vue globaux
Vue.filter('default', function (value, default_value) {
  return value == null ? default_value : value;
});

Vue.filter('from_now', function (value) {
  return moment(value).fromNow();
});

export default {
  name: 'App',
  props: {
    msg: String
  },
  data() {
    return {
      label: ""
    };
  },
  methods: {
    updateTitle() {
      this.$http.get(settings.backendUrl + "/admin/setting/")
          .then((data) => {
            for (let s of data.body.settings) {
              if (s.slug === 'instance_name') {
                this.label = s.value;
                // Met à jour dynamiquement le titre via jQuery
                $('#main_title').text(s.value);
              }
            }
          });
    }
  },
  mounted() {
    const self = this;

    this.updateTitle();

    self.$djangows['onmodelsignals'](
        { modelName: "alert", appLabel: "consultant" },
        (event) => {
          if (event.obj && event.signal_type !== "post_delete") {
            if (event.obj.read === false) {
              self.$store.dispatch("notify", {
                level: event.obj.level,
                text: event.obj.text,
                seconds: event.obj.seconds
              });
            }
          }
        }
    );
  }
};
</script>



<style lang="scss">


/*
$primary: rgb(255, 0, 0);
$link: $blue
$info: $cyan
$success: $green
$warning: $yellow
$danger: $red
$dark: $grey-darker
$text: $grey-dark
*/

html{
    overflow:hidden !important;
    height: 100%;
}
body{
    overflow-x:hidden;
    height: 100%;
}

$gap: 5px;

.clickable {
    cursor: pointer;
}



@import '../node_modules/bulma/bulma.sass';
@import '~bulma-timeline';
@import '../node_modules/bulma-checkradio/dist/css/bulma-checkradio.sass';
@import '~bulma-tooltip';

body{
    font-family: "Nunito Sans", sans-serif;
}

.card-gray {
    background-color: #eee;
}

.state-new{
    @extend .has-background-danger;
    @extend .has-text-white;
}
.state-signalingwriting{
    background-color: cadetblue !important;
    @extend .has-text-white;
}
.state-signalingsent{
    background-color: red !important;
    @extend .has-text-white;
}
.state-answertextvalidation{
    background-color: #ce71f9 !important;
    @extend .has-text-white;
}
.state-answerwriting{
    background-color: #ff9900 !important;
    @extend .has-text-white;
}
.state-modified{
    background-color: #009999 !important;
    @extend .has-text-white;
}
.state-answeraccepted{
    @extend .has-background-info;
    @extend .has-text-white;
}
.state-answerpublished{
    @extend .has-background-success;
    @extend .has-text-white;
}
.state-informationneeded{
    @extend .has-background-warning;
}
.state-waitingforinformation{
    background-color: #ffcb00 !important;
}
.state-translationneeded{
    @extend .has-background-warning;
}
.state-stratalispublication{
    background-color: rgb(12, 116, 177) !important;
    @extend .has-text-white;
}
.state-classified{
    @extend .has-background-grey-light;
}
.fa-thumbs-up{
    color:rgb(35, 209, 96);
}
.fa-thumbs-down{
    color:rgb(255, 56, 96);
}

body{
    font-size: 87.5%;
}


a {
transition: color var(--transition-time-short);
  text-decoration: initial;
  color: var(--primary);
  outline: initial !important;
}


@import './assets/css/vendor/bootstrap.min.css'; 
@import './assets/css/vendor/bootstrap-icon.css';

@import './assets/css/styles.css';
@import './assets/css/main.css';

.datepicker table tr td, .datepicker table tr th {
    padding-top:6px;
}
.datepicker table tr td, .datepicker table tr th, .datepicker table tr td span{
    padding-left:5px;
    padding-right:5px;
}

/* custom scrollbar */
::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}
</style>
